export default {"src":"/_next/static/media/Tick.15446144.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};